var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
export default /*#__PURE__*/React.memo(function SvgSparkles36Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    viewBox: "0 0 36 36",
    role: "presentation",
    "data-ignore-dark-theme-adapter": true
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#D8F0D8",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#59A869",
    d: "M10 15.49A8.31 8.31 0 0 1 15.5 21a8.31 8.31 0 0 1 5.5-5.51A8.25 8.25 0 0 1 15.5 10a8.25 8.25 0 0 1-5.5 5.49M17.992 26A3.14 3.14 0 0 1 20 23.992 3.01 3.01 0 0 1 17.992 22 2.95 2.95 0 0 1 16 23.992 3.01 3.01 0 0 1 17.992 26M23.012 22A4.52 4.52 0 0 1 26 18.988 4.42 4.42 0 0 1 23.012 16 4.52 4.52 0 0 1 20 18.988 4.7 4.7 0 0 1 23.012 22"
  })));
});